import * as yup from 'yup'

export const formValidationSchema = yup.object().required()
